import { Dispatch } from "redux";
import {
  PARAMETROS_URL_REQUEST,
  PARAMETROS_URL_SUCCESS,
  PARAMETROS_URL_FAIL,
} from "./types";
import axiosInstance from '../../../services/axiosConfig';


export const parametrosUrlActions = () => async (dispatch: Dispatch): Promise<boolean> => {

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const url_solicitud: string = import.meta.env.VITE_SOCKET_URL;
  const url_clave_unica: string = import.meta.env.VITE_API_DOBLE_FACTOR;


  dispatch({ type: PARAMETROS_URL_REQUEST });

  try {
    const res = await axiosInstance.post(`${import.meta.env.VITE_CSRF_API_LOGIN}/parametrosUrlActions?url_solicitud=${url_solicitud}&url_clave_unica=${url_clave_unica}`, config);

    if (res.status === 200) {
      dispatch({
        type: PARAMETROS_URL_SUCCESS
      });
      window.location.href = res.data;
      return true;
    } else {
      dispatch({
        type: PARAMETROS_URL_FAIL,
        error:
          "No se pudo registrar los datos ingresados. Por favor, intente nuevamente.",
      });
      return false;
    }
  } catch (err: any) {
    dispatch({
      type: PARAMETROS_URL_FAIL,
      error: err?.message || "Error desconocido",
    });
    return false;
  }
};

